// extracted by mini-css-extract-plugin
module.exports = {"MyBills":"MyBills_MyBills__vc4Px","Title":"MyBills_Title__2Ujs6","InfoBox":"MyBills_InfoBox__LHUaE","InfoTitle":"MyBills_InfoTitle__2olmK","InfoText":"MyBills_InfoText__2zKJf"};